import React from 'react';
import { FormFieldBase, FormFieldInput } from '.';
import {
  getFieldProperties,
  getFieldPropertyValues,
} from './helpers';

export const FormFieldShortText = ({
  field,
  isRenderedField,
  onChange,
  value,
  onBlur,
  validationMessage,
  readOnly
}) => {
  const properties = getFieldProperties(field, ['common', 'specific']);
  const { limit, max } = getFieldPropertyValues(properties.specific, [
    'limit',
    'max'
  ]);
  const options = {
    properties,
    isRenderedField,
    onChange,
    value,
    onBlur,
    validationMessage,
    readOnly
  };

  if (limit) {
    if (max !== undefined && max !== null) options.maxLength = max;
  }

  return <FormFieldInput field={field} options={options} />;
};

FormFieldShortText.defaultProps = {
  isRenderedField: false,
  onChange: () => {},
  value: '',
  onBlur: () => {},
  readOnly: false
};

export default FormFieldBase(FormFieldShortText);
